module.exports = "https://health.dajiuxing.com.cn/img/views/binding/img/xd.jpg"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2Fbinding%2Fimg%2Fxd.jpg
// module id = wNWO
// module chunks = 93